__turbopack_context__.v({
  "className": "anton_7b062a73-module__dcBmnW__className",
  "variable": "anton_7b062a73-module__dcBmnW__variable",
});
